<template>
    <div>
        <div class="label" v-if="label">
            {{ label }}
        </div>
        <div class="chips-wrap">
            <button
                v-for="item in items" :key="item.value"
                :class="['item-chip', {'active': isActive(item.value)}]"
                type="button" @click="setActive(item.value)"
            >
                {{ item.label || item.name }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "ChipSelector",
    props: {
        label: {
            type: String,
            default: ''
        },
        items: {
            type: Array,
            default: () => []
        },
        value: {
            type: String,
            default: ''
        },
        valueArray: {
            type: Array,
            default: () => []
        },
        multiple: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            model: '',
            array: [],
        }
    },
    mounted() {
        this.setDefaults()
    },
    methods: {
        setDefaults() {
            const vm = this
            if (!vm.multiple) return vm.value ? vm.model = vm.value : null
            if (JSON.stringify(vm.array) === JSON.stringify(vm.valueArray)) return
            vm.array = [...vm.valueArray]
        },
        isActive(value) {
            const vm = this
            return vm.multiple ? vm.array.includes(value) : vm.model === value
        },
        setActive(value) {
            const vm = this
            if (!vm.multiple) return vm.model = value
            if (vm.array.includes(value)) vm.array = vm.array.filter(item => item !== value)
            else vm.array = [...vm.array, value]
        },
        reset() {
            const vm = this
            vm.model = ''
            vm.array = []
        }
    },
    watch: {
        model(val) {
            if (!this.multiple) this.$emit('change', val)
        },
        array(val) {
            if (this.multiple) this.$emit('change', val)
        },
        value() {
            this.setDefaults()
        },
        valueArray() {
            this.setDefaults()
        }
    }
}
</script>

<style scoped>

.label {
    font-size: var(--fs-section);
    color: var(--v-txtSecondary-base);
    font-weight: 700;
    margin-bottom: 8px;
}

.chips-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.item-chip {
    padding: 6px 14px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
    border: 1px solid var(--v-outline2-base);
    background: transparent;
    color: var(--v-txtSecondary-base);
    cursor: pointer;
    transition: border-color 0.15s, color 0.15s, background 0.15s;
}

.item-chip:hover {
    border-color: var(--v-secondary-base);
    color: var(--v-secondary-base);
}

.item-chip.active {
    background: rgba(51, 153, 153, 0.15);
    border-color: var(--v-accent-base);
    color: var(--v-accent-base);
}

.theme--dark .item-chip.active {
    color: var(--v-secondary-base);
}

</style>
